import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import BasicEditor from "../../form/BasicEditor";//eslint-disable-line import/no-named-as-default
import * as appDataActions from "../../../actions/appDataActions";
import * as trackingDataActions from "../../../actions/trackingDataActions";
import * as appHelper from "../../../helpers/appHelper";
import * as objectConstants from "../../../constants/objectConstants";
import {TweenLite, Elastic, Bounce, Expo} from "gsap";//eslint-disable-line import/no-named-as-default
//eslint-disable-line import/no-named-as-default
//eslint-disable-line import/no-named-as-default

class TextArea extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            response: this.props.screenObject.response,
        };
        this.onChange = this.onChange.bind(this);
        this.getNextFocusId = this.getNextFocusId.bind(this);
        this.getEditorIndex = this.getEditorIndex.bind(this);
    }

    componentDidMount() {
        this.getNextFocusId();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.screenObject !== nextProps.screenObject) {
            this.setState({screenObject: Object.assign({}, nextProps.screenObject)});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject)
            });
        }
    }

    onChange(value) {
        this.setState({response: value});

        this.props.callbacks.updateField(
            {
                id: this.state.screenObject.id,
                response: value
            }
        );
    }

    getNextFocusId() {
        let questionIndex = appHelper.getArrayObjectIndexByKey(this.props.parentObject.questions, "id", this.state.screenObject.id);
        if (questionIndex < this.props.parentObject.questions.length - 1) {
        let nextQuestion = this.props.parentObject.questions[questionIndex + 1];
        let nextFocusId = `short_response_${nextQuestion.id}`;
           return nextFocusId;
        }else{
            return `${this.props.parentObject.asset_id}_button`;
        }
    }

    getEditorIndex(){
        return appHelper.getArrayObjectIndexByKey(this.props.parentObject.questions, "id", this.state.screenObject.id);
    }

    render() {
        return (
            <div>

                {
                    !this.props.submitted
                        ?
                        <BasicEditor key={this.state.screenObject.id}
                                     name={`field_${this.state.screenObject.id}`}
                                     label={this.state.locale.prompt}
                                     value={this.state.response}
                                     onChange={this.onChange}
                                     wrapperClassName=""
                                     onDoneFocusId={this.getNextFocusId()}
                                     className="standard-no-margin"
                                     index={this.getEditorIndex()}
                        />
                        :
                        <div>
                            <div dangerouslySetInnerHTML={{__html: this.state.locale.prompt}}/>
                            <div className="embedded-response" dangerouslySetInnerHTML={{__html: this.state.response}}/>
                        </div>
                }

                <br/>
            </div>

        );
    }
}

TextArea.propTypes = {
    parentObject: PropTypes.object.isRequired,
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    submitted: PropTypes.bool,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

TextArea.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TextArea);



/** WEBPACK FOOTER **
 ** ./src/components/objects/shortResponse/ShortResponseTextArea.js
 **/